<template>
    <div class="container">
    <div class="e-card">
      <div class="e-card-title"> Manage Web Login User Account </div>
      <div class="e-card-separator"></div>
      <div class="e-card-content">
        <div>
        <div class="form-row">  <!-- && isNewUserAdmin -->
        <div style="width:80%;" class="form-row-input">
          <span v-if="this.notifyErrorMessage"
          style="color:red; display: block; margin-bottom: 2%;">
                {{ notifyErrorMessage }}</span>
            <span v-if="this.notifySuccessMessage"
            style="color:green; display: block; margin-bottom: 2%;">
                {{ notifySuccessMessage }}</span>
          <ejs-textbox
            floatLabelType="Auto"
            v-model="userName"
            placeholder="Email" :readonly="true"></ejs-textbox>
        </div>
        </div>
        <div class="form-row">
                        <div style="width:80%;" class="form-row-input">
                          <scc-input-validator
                         :password="password"
                         @validate="v => this.isPasswordValid=v">
                           <input-password ref="refPassword" v-model="password"
                                            placeholder="New Password" />
                          </scc-input-validator>
                        <span v-show="this.isPasswordValid"
                         class="e-success"><span class="e-icons Selection"></span>
                         Password is strong</span>
                        </div>
                        <div style="width:80%;" class="form-row-input">
                        <scc-input-validator
                         :value="confirmPassword"
                         @validate="v => this.isConfirmPassword=v">
                           <input-password ref="refPassword" v-model="confirmPassword"
                                           placeholder="Confirm Password" />
                          </scc-input-validator>
                         <span v-show="showConfirmPassword"
                         class="e-error"><span class="e-icons close"></span>
                         Confirm password does not match with Password</span>
                         <span v-show="showConfirmPasswordMatch"
                         class="e-success"><span class="e-icons Selection"></span>
                         Password matched</span>
                        </div>
        </div>
        <div class="form-row" style="padding:0px 0px 15px 0px;margin: -5px">
                        <ejs-checkbox label="Force User to Reset Password"
                            v-model="isForcePasswordChange"
                            labelPosition="Before"></ejs-checkbox>
        </div>
        <div class="form-row" style="width:95%;padding:0px 0px 15px 0px;">
                  <span class="e-error">
                         {{passwordValidationMessage}}
                      </span>
                </div>
        <div class="form-row">
                      <div style="width:150px;" class="form-row-input">
                        <label>Active/InActive:</label>
                      </div>
                      <div style="width:150px;" class="form-row-input">
                        <ejs-switch id="status" v-model="isActive"
                                    ref="refStatus"
                                    :checked="isActive"></ejs-switch>
                      </div>
        </div>
        </div>
        <div class="align-center-bottom">
                  <ejs-button type="button"
                    cssClass="e-info margin-button"
                    v-on:click.native="btnSaveUserInfo">Save</ejs-button>
                  <ejs-button v-on:click.native="onCancelButtonClick"
                    cssClass="e-danger margin-button">Cancel</ejs-button>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';

import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { ButtonPlugin, CheckBoxPlugin, SwitchPlugin } from '@syncfusion/ej2-vue-buttons';
import appConfig from '@/app.config';
import SccInputValidator from '../../../components/base/scc-input-validator.vue';
import inputPassword from '../../../components/base/input-password.vue';
import {
  // CHANGE_PASSWORD,
  // REGISTER,
  RESET_PASSWORD,
  DEACTIVATE_USER,
  GET_PASSWORD_LOGS,
} from '../store';
import { FETCH_USER_BY_ID } from '../../auth/store';

Vue.use(TextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);

export default {
  name: 'ManageWebLoginInfo',
  components: {
    SccInputValidator,
    inputPassword,
  },
  props: {
    userProfileId: String,
    userProfilesData: Object,
  },
  mounted() {
  },
  created() {
    this.userId = this.$route.params.id;
    this.getUserById();
  },
  computed: {
    // userEmail() {
    //   return this.$store.getters.loggedUser ? this.userProfilesData.userName : null;
    // },
    // isNewUserAdmin() {
    //   return this.$store.getters.loggedUser
    //     ? (this.$store.getters.loggedUser.email === this.userProfilesData.userName) : false;
    // },
  },
  data() {
    return {
      userName: null,
      email: null,
      userId: null,
      isConfirmPassword: false,
      showConfirmPassword: false,
      isPasswordValid: false,
      isOldPasswordValid: false,
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
      passwordValidationMessage: appConfig.passwordValidationMessage,
      // passwordRule: {
      //   regEx: '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$',
      //   message: 'Password should have at least 8 characters, one uppercase letter,
      //  one lowercase letter,
      // one number and one special character.',
      // },
      password: null,
      confirmPassword: null,
      oldPassword: null,
      showConfirmPasswordMatch: false,
      // showPasswordStrong: false,
      isActive: true,
      isForcePasswordChange: true,
      isResetPasswordSuccess: false,
      isDeactiveUserSuccess: false,
      notifyErrorMessage: '',
      notifySuccessMessage: '',
      passwordLogs: [],
    };
  },
  watch: {
    confirmPassword(val) {
      if (val !== this.password && (this.password !== null || this.password !== '')) {
        this.isConfirmPassword = false;
        this.showConfirmPassword = true;
        this.showConfirmPasswordMatch = false;
      } else if (val === '') {
        this.showConfirmPasswordMatch = false;
      } else {
        this.isConfirmPassword = true;
        this.showConfirmPassword = false;
        this.showConfirmPasswordMatch = true;
      }
    },
    password(val) {
      if (this.confirmPassword === null || this.confirmPassword === '') {
        this.showConfirmPasswordMatch = false;
        this.showConfirmPassword = false;
      } else if (val !== '' && val !== this.confirmPassword) {
        this.isConfirmPassword = false;
        this.showConfirmPassword = true;
        this.showConfirmPasswordMatch = false;
      } else if (val === null || val === '') {
        this.showConfirmPasswordMatch = false;
        this.showConfirmPassword = false;
        this.isConfirmPassword = false;
      } else {
        this.isConfirmPassword = true;
        this.showConfirmPassword = false;
        this.showConfirmPasswordMatch = true;
      }
    },
  },
  methods: {
    async getUserById() {
      try {
        if (this.userId !== 'null' && this.userId !== '') {
          const { userId } = this;
          await this.$store.dispatch(FETCH_USER_BY_ID, { userId });
          this.currentUser = this.$store.getters.userById;
          this.userName = this.currentUser.userName;
        }
      } catch (err) {
        console.error('user accounts err', err);
        if (err.message === 'Network Error') {
          this.$router.push({ name: 'NotFound' });
        } else {
          this.$router.push({ name: 'UnAuthorized' });
        }
      }
    },
    async getPasswordLogsByUserId() {
      const userId = this.userProfileId; // this.$store.getters.loggedUser.id;
      if (userId) {
        await this.$store.dispatch(GET_PASSWORD_LOGS, { userId });
        this.passwordLogs = this.$store.getters.passwordLogs;
      }
    },
    validatePassword() {
      this.password = this.password === null ? '' : this.password;
      this.confirmPassword = this.confirmPassword === null ? '' : this.confirmPassword;
      if (this.userEmail) this.oldPassword = this.oldPassword === null ? '' : this.oldPassword;
    },
    onCancelButtonClick() {
      this.$router.push('/web-user-list');
    },
    async btnSaveUserInfo() {
      try {
        // this.$parent.$parent.notificationToasts.length = 0;
        if (this.password === null && this.confirmPassword === null) {
          // -- do not restet password
          if (!this.isActive) {
            await this.deactivateUser().then(() => {
              this.notifySuccessMessage = 'User User Status save successfully.';
              this.notifyErrorMessage = '';
              this.$parent.$parent.notificationToasts.push({
                title: 'Success!',
                content: this.notifySuccessMessage,
                cssClass: 'e-toast-success',
                timeOut: 5000,
              });
              this.$router.push('/web-user-list');
            });
          }
          // this.$router.push({
          //   name: 'WebUserList',
          //   query: {
          //     refreshTime: new Date(),
          //   },
          // });
        } else if (this.isConfirmPassword && this.isPasswordValid) {
          await this.resetPassword().then(() => {
            this.isResetPasswordSuccess = true;
          });
          if (!this.isActive) {
            await this.deactivateUser().then(() => {
              this.isDeactiveUserSuccess = true;
            });
          } else {
            this.isDeactiveUserSuccess = true;
          }
          // console.log(this.isResetPasswordSuccess, this.isDeactiveUserSuccess);
          if (this.isResetPasswordSuccess && this.isDeactiveUserSuccess) {
            this.notifySuccessMessage = 'User password / User Status save successfully.';
            this.notifyErrorMessage = '';
            this.$parent.$parent.notificationToasts.push({
              title: 'Success!',
              content: this.notifySuccessMessage,
              cssClass: 'e-toast-success',
              timeOut: 5000,
            });
            this.$router.push('/web-user-list');
          } else {
            this.notifySuccessMessage = '';
            this.notifyErrorMessage = 'Please double check required field.';
            this.$parent.$parent.notificationToasts.push({
              title: 'Error!',
              content: this.notifyErrorMessage,
              cssClass: 'e-toast-danger',
              timeOut: 5000,
            });
          }
        } else {
          this.validatePassword();
          this.notifySuccessMessage = '';
          this.notifyErrorMessage = 'Please enter required field.';
          this.$parent.$parent.notificationToasts.push({
            title: 'Error!',
            content: this.notifyErrorMessage,
            cssClass: 'e-toast-danger',
            timeOut: 5000,
          });
        }
      } catch (err) {
        this.notifySuccessMessage = '';
        this.notifyErrorMessage = 'Sorry, Something went wrong during saving information. Please try again later.';
        this.$parent.$parent.notificationToasts.push({
          title: 'Error!',
          content: this.notifyErrorMessage,
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }

      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },

    async resetPassword() {
      try {
        // this.userId = this.userProfileId; // this.$store.getters.confirmedUser.userId;
        const { userId, password } = this;
        await this.$store.dispatch(RESET_PASSWORD, {
          userId, password, forcePasswordChange: this.isForcePasswordChange,
        });
      } catch (err) {
        this.isResetPasswordSuccess = false;
        console.error(err);
      }
    },
    async deactivateUser() {
      try {
        const { userName } = this;
        await this.$store.dispatch(DEACTIVATE_USER, {
          userName,
        });
      } catch (err) {
        console.error(err);
        this.isDeactiveUserSuccess = false;
      }
    },
  },
};
</script>
<style>
@import '../../../assets/styles/eservices-base.css';

.container {
  padding: 10px 15% 16px 10%;
}
 .e-icons{
      /* color: #f44336; */
      font-size: 12px;
}
.close:before{
     content: '\e7fc';
}
.Selection:before{
  content: '\e935';
}
/* .form-row-input {
  vertical-align: middle;
  margin: 5px 10px 5px 0;
  padding: 10px;
} */
.margin-button {
    margin: 25px 5px 20px 20px;
}
.error-container {
  color: red;
  display: block;
  margin-bottom: 2%;
}

</style>
